import React, { useContext } from 'react';
import styled from 'styled-components';
import { CompanyContext } from 'contexts/CompanyContextProvider';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { EpdLinks } from 'routes/EpdRoutes';
import useHeaderAccessToCompanySettings from './useHeaderAccessToCompanySettings';
import { closeHeaderEmitter, media } from './components/headerHelpers';

const HeaderCompanyInfoDrawer: React.FC = () => {
  const { companyId, company } = useContext(CompanyContext);
  const companyAccess = useHeaderAccessToCompanySettings();

  const { t } = useTranslation();

  if (companyAccess.status === 'pending') {
    return <Wrapper>{t('messages.loadingOrganisation')}</Wrapper>;
  }

  if (companyAccess.status === 'error') {
    return <Wrapper>Error</Wrapper>;
  }

  const content = (
    <Wrapper>
      <CompanyName>{company?.name || '[Company name is empty]'}</CompanyName>
      {company?.parentCompany && <HoldingName>Holding: {company.parentCompany.name}</HoldingName>}
    </Wrapper>
  );

  return companyAccess.hasAccess ? (
    <StyledLink to={EpdLinks.manageCompany(companyId!)} onClick={() => closeHeaderEmitter.emitEvent()}>
      {content}
    </StyledLink>
  ) : (
    content
  );
};

export default HeaderCompanyInfoDrawer;

const Wrapper = styled.div`
  padding: 16px 20px;
  border-top: 1px solid ${(props) => props.theme.colors.elementsInputBorder};
  border-bottom: 1px solid ${(props) => props.theme.colors.elementsInputBorder};

  @media ${media.DESKTOP_OR_MORE} {
    display: none;
  }
`;

const CompanyName = styled.div`
  color: ${(props) => props.theme.colors.primaryBlack};
  line-height: 20px;
  font-weight: 600;
`;

const HoldingName = styled.div`
  color: ${(props) => props.theme.colors.primaryBlack70};
`;

const StyledLink = styled(Link)`
  text-decoration: none;

  @media ${media.DESKTOP_OR_MORE} {
    display: none;
  }
`;
